import { emailApiClient } from './emailApiClient';

export interface TransferEmailResponse {
  contactId: string;
}

interface ApiProblemDetails {
  detail?: string;
}

export const transferEmail = async (contactId: string, queueId: string): Promise<TransferEmailResponse> => {
  if (!contactId || !queueId) {
    throw new Error('contactId and queueId are required to transfer an email');
  }

  const response = await emailApiClient('/transfer', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ contactId, queueId })
  });

  if (!response.ok) {
    const errorBody = (await response.json().catch(() => undefined)) as ApiProblemDetails | undefined;
    throw new Error(errorBody?.detail ?? `API responded with status ${response.status}`);
  }

  return (await response.json()) as TransferEmailResponse;
};
